import { useAuth } from "../context/AuthContext";
import { Loader2, WifiOff } from "lucide-react";
import { Button } from "./ui/button";

export function ProtectedRoute({ children }) {
  const { user, retry } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8F6F0] gap-3">
        <img src="/logo.jpg" alt="Affordable Stump Grinding" className="h-16 w-16 rounded-xl object-cover shadow" />
        <Loader2 className="h-6 w-6 animate-spin text-[#1B3B2B]" />
        <p className="text-sm text-slate-500">Loading…</p>
      </div>
    );
  }

  if (user === false) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F8F6F0] gap-4 px-6 text-center">
        <WifiOff className="h-10 w-10 text-slate-400" />
        <p className="text-slate-600 font-medium">Couldn't connect. Please check your internet.</p>
        <Button data-testid="retry-button" onClick={retry} className="bg-[#1B3B2B] hover:bg-[#254F3A] text-white rounded-lg">
          Try Again
        </Button>
      </div>
    );
  }

  return children;
}
